import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            知识分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            系统化的知识体系，帮助您从不同维度深入理解SM文化
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-500 mb-4 group-hover:bg-accent-200/80 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                {cat.name}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center gap-1 text-sm text-primary-500 font-medium">
                浏览文章
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}